// ConvertTableHeaderToTitleCase.ts

/**
 * Converts any string to Title Case.
 *
 * Example:
 *  "business name" -> "Business Name"
 *  "KEYWORDS" -> "Keywords"
 *  "user_id" -> "User Id"
 *  "heatmap keywords" -> "Heatmap Keywords"
 */
export const convertToTitleCase = (str: string): string => {
  if (!str) return "";

  return str
    .replace(/[_-]/g, " ") // replace underscore or dash with space
    .replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
    });
};
